module.exports = __webpack_public_path__ + "static/img/newsImg.289c849d.png";